import { C } from "./theme";

// The app's green action button: under a page's empty-state sentence ("Add a dream", "Add a habit"), and Today's
// "Need help deciding?" Radar. `icon` is a line icon drawn before the words.
export function AddButton({ children, onClick, icon = null, ...rest }) {
  return (
    <button onClick={onClick} {...rest}
      style={{ minHeight: 44, display: "inline-flex", alignItems: "center", gap: 8, background: C.accent, color: C.onAccent, border: "none", borderRadius: C.rsm, padding: "0 16px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
      {icon}{children}
    </button>
  );
}
